import { Box } from "@mui/system";
import useStyles from "./styles";
import { Masonry } from "@mui/lab";
import {
  Alert,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import {
  Add,
  Clear,
  PermContactCalendarOutlined,
  Search,
} from "@mui/icons-material";
import { useEffect, useMemo, useState } from "react";

import RotasVisualizacaoCliente from "./rotasCliente";
import CardPermissao from "../../../../../components/cardPermissao";
import ModalCreatePermissao from "../../../../../components/modalCreatePermissao";
import api from "../../../../../services/api";

export default function Permissoes() {
  const theme = useTheme();
  const [buscarPermissao, setBuscarPermissao] = useState("");
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [routesSelect, setRoutesSelect] = useState([]);
  const [allPermissoes, setAllPermissoes] = useState([]);
  const [permissao, setPermissao] = useState({
    codigoPermissao: "",
    descricao: "",
    color: "",
  });

  const styles = useStyles(theme);

  useEffect(() => {
    getAllPermissoes();
  }, []);

  const handleOpenModal = () => {
    setOpen(true);
  };

  const getAllPermissoes = async () => {
    try {
      const response = await api.get("find/allPermissoesEdit");

      setAllPermissoes(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const filteredPermissoes = useMemo(() => {
    const search = buscarPermissao?.toLowerCase();

    if (!search) return allPermissoes;

    // Função recursiva para verificar se uma página ou seus filhos batem com a busca
    const checkPáginas = (paginas) => {
      if (!paginas || !Array.isArray(paginas)) return false;

      return paginas.some((p) => {
        const matchPagina = p.pagina?.toLowerCase().includes(search);
        // Se a página atual bater, ou se algum filho dela bater, retorna true
        return matchPagina || (p.children && checkPáginas(p.children));
      });
    };

    return allPermissoes.filter((permissao) => {
      const matchCodigo = permissao.codigoPermissao
        ?.toLowerCase()
        .includes(search);
      const matchDescricao = permissao.descricao
        ?.toLowerCase()
        .includes(search);

      // Verifica se o código, a descrição ou QUALQUER página dentro do arrayPermissoes bate
      const matchArrayPermissoes = checkPáginas(permissao.arrayPermissoes);

      return matchCodigo || matchDescricao || matchArrayPermissoes;
    });
  }, [buscarPermissao, allPermissoes]);

  return (
    <Box sx={styles.container}>
      <Paper
        sx={styles.paper}
        elevation={theme.palette.mode === "dark" ? 0 : 3}
      >
        <Box sx={styles.header}>
          <PermContactCalendarOutlined color="primary" />
          <Typography variant="h5" sx={styles.title}>
            Configuração de permissões interno
          </Typography>
        </Box>

        <Box sx={styles.containerHeader}>
          <TextField
            id="input-with-icon-textfield"
            size="small"
            label="Buscar permissão"
            variant="outlined"
            autoComplete="off"
            placeholder="Permissão, descrição, etc..."
            sx={styles.searchInput}
            value={buscarPermissao}
            onChange={(event) => {
              setBuscarPermissao(event?.target?.value?.trimStart());
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: buscarPermissao ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setBuscarPermissao("")}
                    edge="end"
                  >
                    <Clear size={"small"} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
          />
          <Button
            onClick={() => handleOpenModal()}
            startIcon={<Add />}
            variant="contained"
          >
            Criar permissão
          </Button>
        </Box>
        {filteredPermissoes?.length > 0 ? (
          <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={2}>
            {filteredPermissoes?.map((permissao) => (
              <Box key={permissao?.id}>
                <CardPermissao
                  permissao={permissao?.codigoPermissao}
                  colorPermissao={permissao?.color}
                  descricao={permissao?.descricao}
                  countUsers={permissao?.usuarios}
                  totalAcessos={permissao?.totalAcessos}
                  arrayPermissoes={permissao?.arrayPermissoes}
                  permissaoObject={permissao}
                  setAllPermissoes={setAllPermissoes}
                  allPermissoes={allPermissoes}
                  setSnackbar={setSnackbar}
                />
              </Box>
            ))}
          </Masonry>
        ) : (
          <Box sx={styles.noResultsContainer}>
            <Typography sx={styles.noResultsText}>
              Nenhuma permissão encontrada
            </Typography>
          </Box>
        )}
      </Paper>

      {/* Seção separada: aqui é o interno controlando o que existe no portal do
          cliente, diferente do card acima (permissões do próprio console interno) */}
      <Box sx={styles.rotasClienteContainer}>
        <RotasVisualizacaoCliente />
      </Box>

      <ModalCreatePermissao
        setRoutesSelect={setRoutesSelect}
        routesSelect={routesSelect}
        setOpen={setOpen}
        open={open}
        permissao={permissao}
        setPermissao={setPermissao}
        setAllPermissoes={setAllPermissoes}
        setSnackbar={setSnackbar}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
